import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    h2 {
        margin-top: 0;
        margin-bottom: 0.5em;
        color: var(--text-color);
    }

    .body {
        width: 100%;
        height: 100%;
        gap: 1em;
        background-color: #f2f4f7;
        padding: 1em;
    }

    .left {
        width: 35%;
        background-color: transparent;
        border-radius: 10px;
        padding: 0;
        overflow-y: auto;
        gap: 1.3em;
    }

    .right {
        width: 65%;
        background-color: transparent;
        border-radius: 10px;
        padding: 0;
        overflow-y: auto;
    }

    .info-box {
        display: flex;
        flex-direction: column;
        padding: 1em;
        background-color: white;
        border-radius: 0.6em;
        gap: 1em;
    }

    .info-box-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    @media only screen and (max-width: 600px) {
        .body {
            flex-direction: column;
            padding: 0.5em;
        }

        .left,
        .right {
            width: 100%;
            overflow-y: visible;
        }
    }
`;
